const apiHost = process.env.REACT_APP_API_URL || 'https://writersandbox-stage.dsh-agency.com';
const apiUrl = '/api/v1';
const apiPath = `${apiHost}${apiUrl}`

const apiUrlAuth = process.env.REACT_APP_BUILD === 'prod'
  ? 'https://auth-back.dsh-agency.com'
  : 'https://auth-back-stage.dsh-agency.com';

const getTrackerUrl = process.env.REACT_APP_BUILD === 'prod'
  ? 'https://statistic.dsh-agency.com/'
  : 'https://statistic-stage.dsh-agency.com';

const urls = {
  login: apiUrlAuth + '/users/sign_in',

  register: apiPath + '/auth/register',
  logout: apiPath + '/auth/logout',
  user: apiPath + '/auth/user',
  restore: apiPath + '/auth/restore_password',
  requestCode: apiPath + '/phone_verification/send_code',
  stages: apiPath + '/stages',
  tasks: apiPath + '/tasks',
  myTask: apiPath + '/my_task',
  mathTest: apiPath + '/questions',
  subjTest: apiPath + '/questions',
  langTest: apiPath + '/questions',
  geo: 'https://ana.dsh-agency.com/ipinfo/me?geo=1',
  eventLogs: apiPath + '/event_logs'
};

const projectName = 'writers';
const namespace = 'applicant_info';
const trackSiteId = 'sandbox';

export {
  urls,
  projectName,
  namespace,
  getTrackerUrl,
  trackSiteId,
};



// WEBPACK FOOTER //
// ./src/config.js